<template>
  <v-container
    id="regular-forms"
    fluid
    tag="section"
  >
    <base-material-card
      color="#ac8a2e"
      icon="mdi-card-account-details"
      inline
      class="px-5 py-3"
      title="Pedidos de mercado cerrados"
    >
      <v-row
        align="end"
        justify="end"
      >
        <v-col
          cols="5"
        >
          <v-text-field
            v-model="buscar"
            append-icon="mdi-magnify"
            class="ml-auto"
            color="gold"
            label="Buscar"
            hide-details
            single-line
            style="max-width: 250px;"
          />
        </v-col>
        <v-col
          cols="auto"
        >
          <v-dialog
            v-model="dialogDelete"
            max-width="500px"
          >
            <v-card>
              <v-card-title class="headline">
                ¿Realmente desea eliminar?
              </v-card-title>
              <v-card-actions>
                <v-spacer />
                <v-btn
                  color="blue darken-1"
                  text
                  @click="closeDelete"
                >
                  Cancelar
                </v-btn>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="deleteItemConfirm"
                >
                  Aceptar
                </v-btn>
                <v-spacer />
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-col>
        <v-col
          cols="auto"
        >
          <v-dialog
            v-model="dialog"
            max-width="500px"
          >
            <v-card>
              <v-card-title class="headline">
                ¿Realmente desea reabrir el pedido?
              </v-card-title>
              <v-card-actions>
                <v-spacer />
                <v-btn
                  color="blue darken-1"
                  text
                  @click="close"
                >
                  Cancelar
                </v-btn>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="openSeguimientoConfirm"
                >
                  Aceptar
                </v-btn>
                <v-spacer />
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-col>
      </v-row>
      <v-divider class="mt-3" />

      <v-data-table
        :headers="headers"
        :items="pedidos"
        :search.sync="buscar"
        :sort-by="['fecha']"
        :sort-desc="[true, false]"
        multi-sort
      >
        <template v-slot:[`item.actions`]="{ item }">
          <v-tooltip v-if="$can('M_pedidos_edita')" content-class="top" top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small class="mr-2" v-bind="attrs" v-on="on" @click.stop="openSeguimiento(item)">
                mdi-undo-variant
              </v-icon>
            </template>
            <span>Reabrir Pedido</span>
          </v-tooltip>
          <v-tooltip content-class="top" top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small class="mr-2" v-bind="attrs" v-on="on" @click.stop="goToHistorial(item.id)">
                mdi-forum
              </v-icon>
            </template>
            <span>Historial</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </base-material-card>
  </v-container>
</template>

<script>
  export default {
    data () {
      return {
        dialog: false,
        dialogDelete: false,
        buscar: undefined,
        headers: [
          { text: 'Fecha', align: 'start', sortable: true, value: 'fecha' },
          { text: 'Solicitante', sortable: true, value: 'solicitante' },
          { text: 'Club', value: 'club.descripcion' },
          { text: 'Liga', sortable: true, value: 'liga.descripcion' },
          { text: 'Acciones', value: 'actions', sortable: false, align: 'end' },
        ],
        pedidos: [],
        editedIndex: -1,
        menu: false,
        notificar: false,
        showNotificar: false,
        dataForm: {
          id: '',
          fecha: '',
          solicitante: '',
          solicitante_contacto: '',
          club_id: '',
          club: {
            id: '',
            descripcion: '',
          },
          detalle_solicitud: '',
          fecha_cierre: '',
          user_id: 0,
        },
      }
    },
    computed: {
    },
    watch: {
      dialog (val) {
        val || this.close()
      },
    },
    created () {
      this.getPedidos()
    },
    methods: {

      deleteItem (item) {
        this.editedIndex = this.pedidos.indexOf(item)
        this.dataForm = Object.assign({}, item)
        this.dialogDelete = true
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      openSeguimiento (item) {
        this.dataForm = Object.assign({}, item)
        this.dialog = true
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      deleteItemConfirm: async function () {
        await this.$http.delete('/api/pedido_delete/' + this.dataForm.id).then(response => {
          this.$store.commit('toast/show', { tipo: 'success', messages: ['Baja de pedido exitosa'] })
        }).catch(error => {
          if (error.response.data) {
            this.$store.commit('toast/show', { tipo: 'error', messages: [error.response.data] })
          } else {
            this.$store.commit('toast/show', { tipo: 'error', messages: ['Ocurrio un error en el servidor'] })
          }
        })
        this.getPedidos()
        this.closeDelete()
      },

      openSeguimientoConfirm: async function () {
        await this.$http.put('/api/pedido_mercado_abrir/' + this.dataForm.id).then(response => {
          this.$store.commit('toast/show', { tipo: 'success', messages: ['Pedido de mercado abierto'] })
        }).catch(error => {
          if (error.response.data) {
            this.$store.commit('toast/show', { tipo: 'error', messages: [error.response.data] })
          } else {
            this.$store.commit('toast/show', { tipo: 'error', messages: ['Ocurrio un error en el servidor'] })
          }
        })
        this.getPedidos()
        this.close()
      },

      getPedidos: async function () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/pedido_mercado_cerrados' }).then(response => { this.pedidos = response })
      },

      goToHistorial: function (idPedido) {
        this.$router.push({ name: 'Seguimiento pedidos', params: { id: idPedido } })
      },
    },
  }
</script>
